// import React from 'react';

const TEST = process.env.NODE_ENV === 'development';
const backendAddress = TEST ? 'http://localhost:5001' : 'https://rating-backend-jfrpoi655a-ey.a.run.app';
const baseDomain = TEST ? 'http://localhost:3001' : 'https://app.felixmedicus.de';
const website = 'https://felixmedicus.de';

const serviceCredentials = {
  mapsKey: 'AIzaSyCGTnBAGej6cwezP_KEMWYEvQoewy-uuiU'
};

const ratingColors = {
  '-1': '#AB0000',
  0: '#748AFF',
  1: '#017421',
  null: 'grey'
};

const stats = {
  averageBeds: 258
};

const websiteRoutes = {
  dataPrivacy: '/datenschutz',
  agb: '/agb'
};

const clinicSizeMapper = (beds, cb = v => v) => {
  if (beds < 50) return cb(0);
  else if (beds < 150) return cb(1);
  else if (beds < 300) return cb(2);
  else if (beds < 500) return cb(3);
  else return cb(4);
};

const colors = {
  primary: '#FFDA18'
};

const passwordPolicies = [
  'Mindestens 8 Zeichen',
  'Mindestens ein Großbuchstabe',
  'Mindestens ein Kleinbuchstabe',
  'Mindestens eine Zahl'
]

export default {
  clinicSizeMapper,
  stats,
  ratingColors,
  colors,
  baseDomain,
  backendAddress,
  serviceCredentials,
  website,
  websiteRoutes,
  passwordPolicies
};
